import React, { Suspense } from 'react'
import PublicPageLoader from '../../../component/Elements/publicPageLoader'
import { lazyWithRetry } from '../../../helper/lazyWithRetry'

const RecoveryPassword = lazyWithRetry(() => import(/* webpackChunkName: "password" */'../../../component/Recovery/Password'))

const RecoveryPasswordPage = React.memo(() => {
	return (
		<Suspense fallback={<PublicPageLoader className="authPage" />}>
			<RecoveryPassword />
		</Suspense>
	)
})

RecoveryPasswordPage.displayName = 'RecoveryPasswordPage'
export default RecoveryPasswordPage
